import { Heart } from "lucide-react";
import mealPlaceholder from "../assets/meal-placeholder.png";
import { useFavourites } from "@/contexts/FavouritesProvider";

interface ItemProps {
  name: string;
  imageUrl?: string;
  restaurantName: string;
  price: number;
  priceAfterDiscount?: number;
  onClick?: () => void;
  showFavouriteButton?: boolean;
  isFavourite?: boolean;
  onFavouriteClick?: () => void;
}

export default function Item({
  name,
  imageUrl = mealPlaceholder,
  restaurantName,
  price,
  priceAfterDiscount,
  onClick,
  showFavouriteButton = false,
  isFavourite,
  onFavouriteClick,
}: ItemProps) {
  const { removeFavouriteItem } = useFavourites();
  const discount = priceAfterDiscount
    ? ((price - priceAfterDiscount) / price) * 100
    : 0;

  return (
    <div
      className="flex flex-col gap-1.5 sm:gap-2 cursor-pointer"
      onClick={onClick}
    >
      <div className="relative w-full h-40 sm:h-56 lg:h-64 overflow-hidden rounded-lg">
        <img
          src={imageUrl}
          className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-105"
        />
        {showFavouriteButton && (
          <div className="absolute top-2 end-2">
            <button
              onClick={async (e) => {
                e.stopPropagation();
                onFavouriteClick?.();
                // if (isFavouriteItem(item.id)) {
                //   setLoadingFavourites([...loadingFavourites, item.id]);
                //   removeFavouriteItem(await toItem(item));
                //   setLoadingFavourites(
                //     loadingFavourites.filter((id) => id !== item.id)
                //   );
                // } else {
                //   setLoadingFavourites([...loadingFavourites, item.id]);
                //   addFavouriteItem(await toItem(item));
                //   setLoadingFavourites(
                //     loadingFavourites.filter((id) => id !== item.id)
                //   );
                // }
              }}
              className="cursor-pointer bg-primary hover:bg-primary/80 text-white p-1.5 sm:p-2 rounded-full shadow-lg transition-all duration-200 transform hover:scale-110"
            >
              <Heart
                className="w-4 h-4 sm:w-5 sm:h-5"
                fill="white"
                // fill={
                //   isFavouriteItem(item.id) ||
                //   loadingFavourites.includes(item.id)
                //     ? "white"
                //     : "none"
                // }
              />
            </button>
          </div>
        )}
      </div>
      <div className="space-y-0.5">
        <p className="text-sm sm:text-base font-medium line-clamp-2">{name}</p>
        <div className="flex flex-row items-center justify-between">
          <p className="text-xs sm:text-sm text-gray-500">{restaurantName}</p>
          <p className="text-sm sm:text-base font-semibold">{price} ₪</p>
        </div>
      </div>
    </div>
  );

  // return (
  //   <div className="p-1 bg-blue-100" onClick={onClick}>
  //     <div className="hover:scale-105 max-w-64 transition-all duration-300 cursor-pointer">
  //       <div className="relative w-full bg-yellow-300">
  //         <div className="w-full h-48 lg:h-64 bg-orange-300">
  //           <img
  //             src={imageUrl}
  //             className={`object-cover border border-gray-200 w-full h-full transition-all duration-300 ease-in-out rounded-t-md`}
  //           />
  //         </div>

  //         {priceAfterDiscount && (
  //           <div className="absolute top-2 end-2">
  //             <span className="bg-primary-light text-primary font-semibold p-2 text-sm rounded-2xl">
  //               -{discount.toFixed(0)}%
  //             </span>
  //           </div>
  //         )}
  //       </div>

  //       <div
  //         className={`py-4 transition-all duration-300 ease-in-out rounded-b-md flex flex-col gap-0.5 justify-center`}
  //       >
  //         <span>{name}</span>
  //         <div className="flex justify-between items-center">
  //           <span className="text-gray-400 text-sm">
  //             {restaurantName || "Restaurant Name"}
  //           </span>
  //           <span
  //             className={`font-semibold bg-red-300 ${
  //               priceAfterDiscount ? "line-through" : ""
  //             }`}
  //           >
  //             ₪{price}
  //           </span>
  //         </div>
  //         {priceAfterDiscount && (
  //           <div className="flex items-center justify-end gap-1">
  //             <span className="font-semibold bg-primary text-white p-1 rounded-xl">
  //               ₪{priceAfterDiscount}
  //             </span>
  //           </div>
  //         )}
  //       </div>
  //     </div>
  //   </div>
  // );
}
